import script from "./LocationsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationsView.vue?vue&type=script&setup=true&lang=ts"

import "./LocationsView.vue?vue&type=style&index=0&id=5f3ab3b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3ab3b4"]])

export default __exports__